/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="67.29"
        height="92.61"
        viewBox="0 0 67.29 92.61"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M57.19 0H10.12A9.68 9.68 0 0 0 .46 9.66V67a9.68 9.68 0 0 0 9.66 9.66h47.07A9.68 9.68 0 0 0 66.85 67V9.66A9.68 9.68 0 0 0 57.19 0ZM10.12 2.5h47.07a7.18 7.18 0 0 1 7.16 7.16V67a7.18 7.18 0 0 1-7.16 7.16H10.12A7.18 7.18 0 0 1 3 67V9.66a7.18 7.18 0 0 1 7.12-7.16Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M56.54 16H10.77a1.25 1.25 0 0 0-1.25 1.25v26.34a1.25 1.25 0 0 0 1.25 1.25h45.77a1.25 1.25 0 0 0 1.25-1.25V17.23A1.25 1.25 0 0 0 56.54 16Zm-1.25 2.5v23.84H12V18.48Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M24.29 8.1H43a1.252 1.252 0 1 1 .13 2.5H24.29a1.252 1.252 0 1 1-.13-2.5ZM16.39 50.65a6.92 6.92 0 1 0 6.91 6.93 6.93 6.93 0 0 0-6.91-6.93Zm0 2.5A4.42 4.42 0 1 1 12 57.58a4.43 4.43 0 0 1 4.39-4.43ZM50.86 50.65a6.92 6.92 0 1 0 6.93 6.91 6.92 6.92 0 0 0-6.93-6.91Zm0 2.5a4.42 4.42 0 1 1-4.41 4.43 4.43 4.43 0 0 1 4.41-4.43Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M17.9 74.69a1.25 1.25 0 0 1 1.77 1.76l-.1.1L2.09 92.29a1.26 1.26 0 0 1-1.77-.09 1.26 1.26 0 0 1 0-1.67l.09-.1ZM47.86 74.9a1.25 1.25 0 0 1 1.65-.17l.11.09 17.27 15.61a1.25 1.25 0 0 1-1.57 1.94l-.1-.08-17.28-15.62a1.25 1.25 0 0 1-.08-1.77Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'SubwayTrainOnTracksIcon';

export default Icon;
